import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#0f3442"
					title={"West Coast Waste"}
					image={require('./video.jpg')}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">Creating a one-step checkout for customers.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/WCW.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">When you're ordering a skip bin, what do you want to find out first? <p></p>
We put ourselves in the user's shoes to create a new site for the amazing West Coast Waste team that answers the first question most bin hirers have: how much will this cost me?</div>

	</div>
						</div>
					</div>

<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-10">
<p></p>
<img src={require('./example-1.jpg')} alt="West Coast Waste" width="100%" />
<p></p>
				



<br></br>
								<p>This new design simply requires the postcode of the customer to create an instant quote on delivery costs. Not only that, it's also highly visual to give easy comparisons between each skip bin size. </p><br></br>
<h2>Results that speak volumes</h2>
<p>In fact, the redesign of the WCW site has been so successful, that in the month they've been live, we've seen a <b>600% increase in online bin orders</b>. That's what understanding your customers can bring to  your business!</p>

<br></br>

<a class="btn" href="https://www.westcoastwaste.com.au">Visit The Site</a>
			</div>	 
</div>	
</div>					
						

										
				


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/WestCoastWaste/index.js